import ReactDOM from "react-dom";

function RoleSelectionModal({ onSelect, loading }) {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm mx-4">
        <h2 className="text-xl font-bold text-gray-900 mb-2 text-center">
          Select Login Role
        </h2>
        <p className="text-sm text-gray-500 text-center mb-6">
          Your account has multiple roles. Choose how you want to log in.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => onSelect("bdo")}
            disabled={loading}
            className="w-full py-3 px-4 rounded-xl border-2 border-primary-600 text-primary-600 font-semibold hover:bg-primary-50 transition-colors disabled:opacity-50"
          >
            BDO
          </button>
          <button
            onClick={() => onSelect("hospital")}
            disabled={loading}
            className="w-full py-3 px-4 rounded-xl border-2 border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Hospital User
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default RoleSelectionModal;
